export const milestonesColumnsConfig = [
  {
    key: 'ca_aps',
    label: 'CA/APS',
    milestoneName: 'CA/APS',
    approvalRequired: true,
    async: false
  },
  {
    key: 'mvp',
    label: 'MVP',
    milestoneName: 'MVP',
    approvalRequired: true,
    async: false
  },
  {
    key: 'gtms',
    label: 'GTMS',
    milestoneName: 'GTMS',
    approvalRequired: true,
    async: false
  },
  {
    key: 'e2e1',
    label: 'E2E1',
    milestoneName: 'E2E1',
    approvalRequired: true,
    async: true
  },
  {
    key: 'brnd',
    label: 'BRND',
    milestoneName: 'BRND',
    approvalRequired: true,
    async: false
  },
  {
    key: 'montzn',
    label: 'MONTZN',
    milestoneName: 'MONTZN',
    approvalRequired: true,
    async: false
  },
  {
    key: 'media_brainstorm',
    label: 'MEDIA BRAINSTORM',
    milestoneName: 'Media Brainstorm',
    approvalRequired: false,
    async: false
  },
  {
    key: 'gtmp',
    label: 'GTMP',
    milestoneName: 'GTMP',
    approvalRequired: true,
    async: true
  },
  {
    key: 'creative_arch',
    label: 'CREATIVE ARCH',
    milestoneName: 'Creative Arch',
    approvalRequired: true,
    async: true
    // width: '180px'
  },
  {
    key: 'e2e2',
    label: 'E2E2',
    milestoneName: 'E2E2',
    approvalRequired: true,
    async: true
  },
  {
    key: 'media',
    label: 'MEDIA',
    milestoneName: 'Media',
    approvalRequired: true,
    async: false
  },
  {
    key: 'rr1',
    label: 'RR1',
    milestoneName: 'RR1',
    approvalRequired: false,
    async: true
  },
  {
    key: 'rr2',
    label: 'RR2',
    milestoneName: 'RR2',
    approvalRequired: false,
    async: true
  },
  {
    key: 'mktg_pkg',
    label: 'MKTG PKG',
    milestoneName: 'Mktg Pkg',
    approvalRequired: false,
    async: true
  },
  // Phase Dates columns
  {
    key: 'internal_beta',
    label: 'INTERNAL BETA',
    phaseDate: true,
    dateField: 'internalBeta'
  },
  {
    key: 'private_beta',
    label: 'PRIVATE BETA',
    phaseDate: true,
    dateField: 'privateBeta'
  },
  {
    key: 'public_beta',
    label: 'PUBLIC BETA',
    phaseDate: true,
    dateField: 'publicBeta'
  },
  {
    key: 'ga',
    label: 'GA',
    phaseDate: true,
    dateField: 'ga'
  }
];
